module.exports = __webpack_public_path__ + "img/img1_mobile.7059b0de.png";